export function getPropertyName(name) {
  if (name && name.toLowerCase().includes('goodwin')) {
    return 'The Goodwin'
  }
  return name
}
